// ---- Skill certificate files -----------------------------------------------
//
// One PDF per skill rating, uploaded by the employee from My Skill and
// downloadable by them, their direct manager, a pending approver of the
// rating, and anyone who can already see their skill ratings. Shared so the
// browser can refuse a wrong file before uploading it, with the same limits
// the API enforces.

const MAX_SKILL_CERTIFICATE_MB = 2;

/** Largest certificate file accepted. */
export const MAX_SKILL_CERTIFICATE_BYTES = MAX_SKILL_CERTIFICATE_MB * 1024 * 1024;

/** The limit as people read it, for messages. */
export const MAX_SKILL_CERTIFICATE_LABEL = `${MAX_SKILL_CERTIFICATE_MB} MB`;

/** The only type accepted — and the type it is always served as. */
export const SKILL_CERTIFICATE_CONTENT_TYPE = 'application/pdf';

/** Every PDF starts with these bytes. Checked on top of the extension, so a
 *  renamed file of another type is refused rather than stored as a "PDF". */
export const PDF_MAGIC = '%PDF-';

/**
 * Why `file` can't be a skill certificate, or null when it can. Name, size
 * and emptiness only — the server additionally checks the PDF signature.
 *
 * The over-limit message states the limit, not the file's size: a file just
 * over it rounds to the same figure ("2.0 MB"), which reads as allowed.
 */
export function skillCertificateProblem(file: { name: string; size: number }): string | null {
  if (!file.name.toLowerCase().endsWith('.pdf')) return `${file.name} is not a PDF.`;
  if (file.size === 0) return `${file.name} is empty.`;
  if (file.size > MAX_SKILL_CERTIFICATE_BYTES) {
    return `${file.name} is too large. Certificates can be up to ${MAX_SKILL_CERTIFICATE_LABEL}.`;
  }
  return null;
}
